export const PATH = {
  game: '/game',
  book: '/book',
  statistic: '/statistic',
};

export const PROFILE_PATH = {
  login: '/login',
  register: '/registration',
};

export const GAME_PATH = {
  audio: './audio',
  sprint: './sprint',
};
export const MAIN_PATH = {
  textbook: '/book',
  game: '/game',
  statistic: '/statistic',
};
